import React, { Fragment, useState } from "react";
import Dropdown from "../components/form/Dropdown";
import Indentification from "../components/elements/Indentification";
import { initialsValue } from "../helpers";
import { useNavigate } from "react-router-dom";
import Modal from "../components/elements/Modal";
import Button from "../components/form/Button";

import LogoutModal from "../components/LogoutModal/LogoutModal";

const AuthDropdown = ({ user }) => {
  const navigate = useNavigate();
  const [isLogoutModelOpen, setIsLogOutModelOpen] = useState(false);
  const userDropdownData = [
    {
      name: "Dashboard",
      icon: "fa-regular fa-table-cells", // Matches 2x2 grid icon
      standout: false,
      click: () => {
        navigate("/user/dashboard");
      },
    },
    {
      name: "Applications",
      icon: "fa-regular fa-envelope", // Same as dashboard icon in image
      standout: false,
      click: () => {
        navigate("/user/applications");
      },
    },
    {
      name: "Communications",
      icon: "fa-regular fa-comments", // Speech bubbles icon
      standout: false,
      click: () => {
        navigate("/user/communications");
      },
    },
    {
      name: "Resource Libary",
      icon: "fa-regular fa-file", // Document/paper icon
      standout: false,
      click: () => {
        navigate("/user/resource-library");
      },
    },
    {
      name: "Profile Information",
      icon: "fa-regular fa-clipboard", // Clipboard with text icon
      standout: false,
      click: () => {
        navigate("/user/profile");
      },
    },
    {
      name: "Logout",
      icon: "fa-solid fa-right-from-bracket", // Arrow-from-box icon
      standout: true,
      click: () => {
        setIsLogOutModelOpen(true);
        // localStorage.clear();
        // sessionStorage.clear();
        // navigate("/");
      },
    },
  ];

  const donorDropdownData = [
    {
      name: "Dashboard",
      icon: "fa-solid fa-table-cells", // Matches 2x2 grid icon
      standout: false,
      click: () => {
        navigate("/donor/donation");
      },
    },
    {
      name: "Logout",
      icon: "fa-solid fa-right-from-bracket", // Arrow-from-box icon
      standout: true,
      click: () => {
        setIsLogOutModelOpen(true);
        // localStorage.clear();
        // sessionStorage.clear();
        // navigate("/");
      },
    },
  ];

  const adminDropdownData = [
    {
      name: "Dashboard",
      icon: "fa-regular fa-table-cells", // Matches 2x2 grid icon
      standout: false,
      click: () => {
        navigate("/admin/dashboard");
      },
    },
    {
      name: "Settings",
      icon: "fa-regular fa-envelope", // Same as dashboard icon in image
      standout: false,
      click: () => {
        navigate("/admin/site-settings");
      },
    },
    {
      name: "Profile Information",
      icon: "fa-regular fa-clipboard", // Clipboard with text icon
      standout: false,
      click: () => {
        navigate("/admin/profile");
      },
    },
    {
      name: "Logout",
      icon: "fa-solid fa-right-from-bracket", // Arrow-from-box icon
      standout: true,
      click: () => {
        setIsLogOutModelOpen(true);
        // localStorage.clear();
        // sessionStorage.clear();
        // navigate("/");
      },
    },
  ];
  return (
    <>
      <Dropdown
        data={
          user?.role === "donor"
            ? donorDropdownData
            : user?.role === "admin"
            ? adminDropdownData
            : userDropdownData
        }
        buttonClasses={"!p-0 border-0"}
        button={
          <Indentification
            initial={initialsValue(`${user?.firstName} ${user?.lastName}`)}
            image={user?.image?.url || user?.image}
            size="sm"
          />
        }
        xPlacement="bottomRight"
        dropdownContainer={"!py-0 !mt-[10px] !rounded-none"}
        headerdropdownlabel={"py-2 border-b border-slate-200 last:border-b-0"}
        headerlabelicon={
          "bg-primary/40 w-7 h-7 rounded-full text-[10px] flex-shrink-0"
        }
        headerlabel={"text-xs"}
      />

      <LogoutModal
        setIsOpen={(val) => setIsLogOutModelOpen(val)}
        isOpen={isLogoutModelOpen}
      />
    </>
  );
};

export default AuthDropdown;
